import { createAction } from '@ngrx/store';
import { AddOrganizationUserFormModel } from '@spog-ui/shared/models/organization-users';

export const enterAction = createAction('[Organization Admin / Add User] Enter');

export const addUserAction = createAction(
  '[Organization Admin / Add User] Add User',
  (User: AddOrganizationUserFormModel) => ({ User }),
);
